<template lang="pug">
  picture
    source(v-if="webp", :srcset="webpSrc", type="image/webp")
    source(:srcset="cdnSrc", :type="imgType")
    img(:src="cdnSrc", :alt="title", :class="imgClass", :style="imgStyle")
</template>

<script>
export default {
  name: 'BLBPicture',
  props: {
    imgClass: {
      type: String,
      default: '',
    },
    imgExt: {
      type: String,
      default: 'jpg',
    },
    imgStyle: {
      type: Object,
      default: () => {},
    },
    src: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: 'image',
    },
    webp: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    cdnSrc() {
      // check if it's not relative path
      if (this.src && this.src.charAt(0) !== '/') return this.src;
      // STAGING: inspect if assets url are not relative either
      if (`${process.env.ASSETS_URL}`.charAt(0) === '/') return this.src;
      // return the replaced value
      return `${process.env.ASSETS_URL !== undefined ? process.env.ASSETS_URL : ''}${this.src}`;
    },
    webpSrc() {
      return `${this.cdnSrc}.webp`;
    },
    ext() {
      return this.src !== '' && this.src.includes('.') ? this.src.split('.').pop() : this.imgExt;
    },
    imgType() {
      return `image/${this.ext}`;
    },
  },
};
</script>
